import { render, staticRenderFns } from "./TradeGenerationContainer.vue?vue&type=template&id=1ec859f0"
import script from "./TradeGenerationContainer.vue?vue&type=script&lang=js"
export * from "./TradeGenerationContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports